import { useEffect, useState } from "react";
import { api, fmtDateTime } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { RagBadge, STAGE_LABELS } from "./Badges";

export const AssetHistory = ({ asset, onClose }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (asset) api.get(`/assets/${asset.id}/history`).then((r) => setData(r.data));
    else setData(null);
  }, [asset]);

  return (
    <Dialog open={!!asset} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[85vh] overflow-y-auto border-slate-700 bg-ink-2 sm:max-w-xl" data-testid="asset-history-dialog">
        <DialogHeader><DialogTitle className="font-display text-xl uppercase">Service history - {asset?.name}</DialogTitle></DialogHeader>
        <p className="eyebrow">Inspections</p>
        <div className="space-y-2">
          {(data?.inspections || []).map((i) => (
            <div key={i.id} className="flex items-center justify-between rounded border border-slate-800 p-2 text-sm">
              <span>{i.template_name}<span className="block text-xs text-slate-500">{fmtDateTime(i.performed_at)} - {i.performed_by}</span></span>
              <RagBadge status={i.outcome === "pass" ? "green" : "red"} label={i.outcome} />
            </div>
          ))}
          {data && !data.inspections.length && <p className="text-sm text-slate-500">No inspections recorded.</p>}
        </div>
        <p className="eyebrow mt-2">Work orders</p>
        <div className="space-y-2">
          {(data?.work_orders || []).map((w) => (
            <div key={w.id} className="flex items-center justify-between rounded border border-slate-800 p-2 text-sm">
              <span><span className="font-mono text-cyan-300">{w.ref}</span> {w.title}<span className="block text-xs text-slate-500">{fmtDateTime(w.created_at)}</span></span>
              <span className="text-xs text-slate-300">{STAGE_LABELS[w.stage]}</span>
            </div>
          ))}
          {data && !data.work_orders.length && <p className="text-sm text-slate-500">No work orders.</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
};
